<ng-template #toggleTpl>
  @if (!loading && !isAdmin && changeProfile && !welcomeMessage) {
    <p-selectButton (onChange)="onChangeProfile($event)" [options]="profiles"
    [(ngModel)]="profile" optionLabel="label" optionValue="value"></p-selectButton>
  }
</ng-template>

<ng-template #actionTpl>
  @if (!loading && !isAdmin) {
    <div class="flex align-items-center">
      @for (e of eventTypes; track e; let i = $index) {
        @if (disableButton(e) && e.actionType!=jobAction) {
          <p-button (click)="sendEvent(e,false)" [disabled]="saving"
          class="mr-3" [icon]="getIconEvent(e)" [label]="e.name"></p-button>
        }
        @if (disableButton(e) && e.actionType==jobAction) {
          <p-splitButton [label]="labelJobAction" [disabled]="saving"
            [icon]="iconJobAction" (onClick)="startWork(isRemoteWork)" [model]="items"
          class="mr-3"></p-splitButton>
        }
      }
      <app-status-timer [initialValue]="initDate" [start]="isWorking(status)"></app-status-timer>
    </div>
  }
</ng-template>

@if (!compact) {
  <div [ngClass]="{'status':(!isMobile() || isOverlay() || isHorizontal())
      &&!welcomeMessage, 'status-mobile':(isMobile() || isOverlay() || isHorizontal())&&!welcomeMessage}">
    @if (!loading && !isAdmin) {
      <div [class]="welcomeMessage?'no-card':'card'">
        @if (welcomeMessage) {
          <div class="w-full mb-3 text-center">
            Bienvenido {{userName}}
          </div>
        }
        <div [class]="'w-full flex-wrap flex flex-row' + (welcomeMessage?' justify-content-center':'')">
          @if (changeProfile &&!welcomeMessage) {
            <div class="flex justify-content-start mb-2">
              <ng-container *ngTemplateOutlet="toggleTpl"></ng-container>
            </div>
          }
          <div [class]="welcomeMessage?'flex mb-2':'flex flex-grow-1 justify-content-end mb-2'">
            <ng-container *ngTemplateOutlet="actionTpl"></ng-container>
          </div>
        </div>
      </div>
    }
  </div>
}